'use client';

import { c as _c } from "react/compiler-runtime";
import style from '@components/horizontal-scroll/HorizontalScroll.module.scss';
import ParallaxMedia from '@components/parallax-media/ParallaxMedia';
import Gradient_4_mob from '@images/gradients/gradient_4_mob.webp';
import Gradient_5 from '@images/gradients/gradient_5.webp';
import { scrollInfrastructure, scrollLocation } from '@lib/tools/helpers/constants';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import { useViewport } from '@lib/tools/hooks/useViewport';
import cn from 'classnames';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import NextImage from 'next/image';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
function SliderLocationMob() {
  const $ = _c(23);
  const [classNames, setClassNames] = useState(style.horizontalScrollContainer);
  const horizontalRef = useRef(null);
  const scrollRef = useRef(null);
  const {
    viewport,
    isPortrait,
    isLandscape,
    isDesktop,
    isMobile,
    userAgent
  } = useViewport();
  const [st1, setSt1] = useState(null);
  const [st2, setSt2] = useState(null);
  const [st3, setSt3] = useState(null);
  const [st4, setSt4] = useState(null);
  let t0;
  if ($[0] !== isDesktop || $[1] !== isLandscape || $[2] !== isPortrait || $[3] !== userAgent) {
    t0 = () => {
      if (scrollRef && horizontalRef && !isDesktop && (isPortrait || isLandscape && userAgent === "none")) {
        setClassNames(_temp);
        setTimeout(() => {
          scrollInfrastructure.forEach((_, index) => {
            let rotateN;
            if (scrollInfrastructure[index].rotate > 0) {
              rotateN = 6;
            } else {
              rotateN = -6;
            }
            setSt4(ScrollTrigger.create({
              animation: gsap.to(horizontalRef.current.children[index], {
                transform: `rotate(${scrollInfrastructure[index].rotate + rotateN}deg)`,
                ease: "slow"
              }),
              trigger: scrollRef.current,
              start: "bottom bottom",
              scroller: ".horizontal",
              horizontal: true,
              scrub: true
            }));
            return null;
          });
        }, 1000);
      }
    };
    $[0] = isDesktop;
    $[1] = isLandscape;
    $[2] = isPortrait;
    $[3] = userAgent;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== isLandscape || $[6] !== userAgent || $[7] !== viewport) {
    t1 = [viewport, scrollRef, horizontalRef, isLandscape, userAgent];
    $[5] = isLandscape;
    $[6] = userAgent;
    $[7] = viewport;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  useLayoutEffect(t0, t1);
  let t2;
  if ($[9] !== st1 || $[10] !== st2 || $[11] !== st3 || $[12] !== st4) {
    t2 = () => () => {
      st1?.kill();
      st2?.kill();
      st3?.kill();
      st4?.kill();
      setSt1(null);
      setSt2(null);
      setSt3(null);
      setSt4(null);
    };
    $[9] = st1;
    $[10] = st2;
    $[11] = st3;
    $[12] = st4;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  useEffect(t2, t3);
  let t4;
  if ($[15] !== classNames) {
    t4 = cn(classNames, "horizontal");
    $[15] = classNames;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== isMobile || $[18] !== viewport) {
    t5 = scrollLocation && <div className={style.horizontalScrollWrapperMob} ref={horizontalRef}>{scrollLocation.map(item => <div key={item.src} className={cn(style.horizontalScrollItem, item.style)} style={{
        transform: `rotate(${item.rotate}deg)`,
        top: `${item.top}%`
      }}><SafeHtmlRenderer className={style.horizontalScrollImgTitle} tag="div" content={item.text || ""} /><ParallaxMedia onMove={true} src={item.src} src375={item.srcXS} className={style.horizontalScrollImg} />{viewport && <NextImage loading="lazy" decoding="async" src={!isMobile ? Gradient_5 : Gradient_4_mob} alt="gradient" className={style.horizontalScrollImgGradient} />}</div>)}</div>;
    $[17] = isMobile;
    $[18] = viewport;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t4 || $[21] !== t5) {
    t6 = <div className={t4} ref={scrollRef}>{t5}</div>;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
}
function _temp(prev) {
  return cn(prev, style.__horizontalScroll);
}
export default SliderLocationMob;